// extracted by mini-css-extract-plugin
export var attribution = "_bl-4";
export var authorName = "_bl-5";
export var quote = "_bl-3";
export var testimonial = "_bl-2";
export var trustedBy = "_bl-0";
export var trustedByLabel = "_bl-1";